export default __webpack_public_path__ + "static/media/icon_profile.75c903e8.svg";